export default "__VITE_ASSET__DaHpxuFS__"